import Crud from "../Crud";
import MUIBlueColor from "@mui/material/colors/blue";

/**
 * Static helper functions related to dashboards.
 */
export default class Dashboard extends Crud {
  /**
   * @param {object} dashboard The dashboard object.
   * @returns The display name of the dashboard.
   */
  static getDisplayName(dashboard) {
    return dashboard.name;
  }

  /**
   * Determines if a dashboard matches a search query.
   *
   * @param {object} dashboard The dashboard to test.
   * @param {string} query The search query.
   * @returns {boolean} Whether or not the dashboard matches the query.
   */
  static match(dashboard, query) {
    return (
      (dashboard.name && dashboard.name.toLowerCase().includes(query)) ||
      dashboard.id === +query
    );
  }

  /**
   * @param {array} dashboards The list to sort.
   * @returns {array} The sorted list.
   */
  static sort(dashboards) {
    return dashboards.sort((a, b) => a.name.localeCompare(b.name));
  }

  /**
   * @returns {string} The color of this object.
   */
  static getBaseColor() {
    return MUIBlueColor;
  }

  /**
   * @returns {string} The icon name for this object.
   */
  static getIconName() {
    return "Dashboard";
  }

  /**
   * Get the dashboard widget rows for the dashboard
   * @param {string} dashboardId - The ID of the dashboard
   * @param {object} dashboardWidgetsIndexed - The indexed dashboard widgets
   * @returns {array} The dashboard widget rows
   */
  static getDashboardWidgetRows(dashboardId, dashboardWidgetsIndexed) {
    return Object.values(dashboardWidgetsIndexed).filter(
      (dashboardWidget) =>
        dashboardWidget.dashboardId === parseInt(dashboardId),
    );
  }

  /**
   * Get the widgets for the dashboard
   * @param {array} dashboardWidgetRows - The dashboard widget rows
   * @param {object} widgetsIndexed - The indexed widgets
   * @returns {array} The widgets
   */
  static getWidgetsForDashboard(dashboardWidgetRows, widgetsIndexed) {
    return dashboardWidgetRows
      .map((dashboardWidget) => widgetsIndexed[dashboardWidget.widgetId])
      .filter((widget) => widget !== undefined);
  }

  /**
   * Determines if the current route is a dashboard route.
   * @returns {boolean} Whether or not the current route is a dashboard route.
   */
  static isDashboardRoute() {
    return window.location?.pathname?.startsWith("/dashboard/") === true;
  }
}
